import cloneDeep from "lodash/cloneDeep";
import isEmpty from "lodash/isEmpty";
import * as api from "../../api/eventsApi";
import type { EventMarketPeriodType, EventType } from "../../types/eventType";
import type { SingleEventModelType } from "../../types/rematchTypes";

/**
 * reducers: `myFunc(state, payload)`
 * effects:  `async myFunc(payload, rootState)`
 */
const SingleEventModel = {
  state: {
    singleEvent: {} as {},
    widgetExpanded: false,
  },
  reducers: {
    setEvent(
      state: SingleEventModelType,
      payload: EventType
    ): {
      singleEvent: EventType;
    } {
      return { ...state, singleEvent: payload };
    },

    updateEvent(
      state: SingleEventModelType,
      payload: EventType
    ): {
      singleEvent: any;
    } {
      let oldEvent = cloneDeep(state.singleEvent);

      // check if we have an event to update
      if (!isEmpty(oldEvent)) {
        // check if we have any market periods in the new event (payload)
        if (!isEmpty(payload.marketPeriods)) {
          payload.marketPeriods.forEach(marketPeriod => {
            const foundOldMarketPeriod = oldEvent.marketPeriods.find(
              foundOldMarketPeriod =>
                marketPeriod.marketPeriod === foundOldMarketPeriod.marketPeriod
            );

            if (foundOldMarketPeriod != null) {
              marketPeriod.isActive = foundOldMarketPeriod.isActive;
            }
          });
        }

        Object.assign(oldEvent, payload);
      }

      return { ...state, singleEvent: oldEvent };
    },

    resetEvent(state: SingleEventModelType): {
      singleEvent: {};
    } {
      return { ...state, singleEvent: {} };
    },

    toggleWidget(state: SingleEventModelType, payload: boolean) {
      return { ...state, widgetExpanded: payload };
    },

    setMarketPeriod(
      state: Record<string, any>,
      payload: EventMarketPeriodType
    ): any {
      let singleEvent = { ...state.singleEvent };
      singleEvent.marketPeriods.forEach((marketPeriod, index) => {
        if (marketPeriod.marketPeriod === payload.marketPeriod) {
          singleEvent.marketPeriods[index] = payload;
        }
      });
      return { ...state, singleEvent };
    },
  },
  effects: {
    async loadEvent(
      payload: Record<string, any>,
      rootState: Record<string, any>
    ) {
      api
        .fetchEventDetails(payload.eventId, false, payload.marketGroupType)
        .then((event: EventType) => {
          this.setEvent(event);
        })
        .catch(error => {
          console.log(error);
        });
    },
  },
};
export default SingleEventModel;
